export const SERVER = process.env.NEXT_PUBLIC_SERVER_URI
export const IMAGE_URL = process.env.NEXT_PUBLIC_IMAGE_URI
export const WEBSOCKET_SERVER = process.env.NEXT_PUBLIC_WEBSOCKET_SERVER??''
export const DOMAIN = process.env.NEXT_PUBLIC_DOMAIN??''
export const NEXT_PUBLIC_SERVER_MAIN_URI = process.env.NEXT_PUBLIC_SERVER_MAIN_URI??""